import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../../core/services/api.service';
import { ApiResponse } from '../../../core/shared/classes/api';
import { Article } from '../classes/article';
import { CategorieArticle } from '../classes/categorie-article';
import { TypeQuantite } from '../classes/type-quantite';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private apiService: ApiService) { }

  getList(params?: {currentPage: number, maxItemPerPage: number, searchTerm?: string}): Observable<ApiResponse> {
    return this.apiService.get(`article`, null, params);
  }

  getAll(): Observable<ApiResponse> {
    return this.apiService.get(`article/all`);
  }

  get(artId: number): Observable<ApiResponse> {
    return this.apiService.get(`article/${artId}`);
  } 

  create(article: Article): Observable<ApiResponse> {
    return this.apiService.post(`article`, article.toJSON());
  }

  update(artId: number, article: Article): Observable<ApiResponse> {
    return this.apiService.put(`article/${artId}`, article.toJSON());
  }

  delete(artId: number): Observable<ApiResponse> {
    return this.apiService.delete(`article/${artId}`);
  }
  
  getArticles(categoryId = ''): Observable<Article[] | Article> {
    return this.apiService.get(`article/${categoryId}`).pipe(map(reponse => {
      if (reponse.status === 200 && reponse.data) {
        if (categoryId !== '') {
          return new Article(reponse.data);
        }  else {
          const articles: Article[] = [];
  
          if (reponse.data.length > 0) {
            reponse.data.forEach(d => {
              articles.push(new Article(d));
            });
          } 
          return articles;
        }
      } else {
        return [];
      }
    }));
  }

  getCategorieList(params?: {currentPage: number, maxItemPerPage: number}): Observable<ApiResponse> {
    return this.apiService.get(`article-categorie`, params);
  }

  insertCategorie(cat: CategorieArticle): Observable<ApiResponse> {
    return this.apiService.post(`article-categorie`, cat.toJSON());
  }

  updateCategorie(acaId: number, cat: CategorieArticle): Observable<ApiResponse> {
    return this.apiService.put(`article-categorie/${acaId}`, cat.toJSON());
  }

  deleteCategorie(acaId: number): Observable<ApiResponse> {
    return this.apiService.delete(`article-categorie/${acaId}`);
  }

  getTypeQuantiteList(params?: {currentPage: number, maxItemPerPage: number}): Observable<ApiResponse> {
    return this.apiService.get(`article-type-quantite`, params);
  }

  insertTypeQuantite(type: TypeQuantite): Observable<ApiResponse> {
    return this.apiService.post(`article-type-quantite`, type.toJSON());
  }

  updateTypeQuantite(atqId: number, type: TypeQuantite): Observable<ApiResponse> {
    return this.apiService.put(`article-type-quantite/${atqId}`, type.toJSON());
  }

  deleteTypeQuantite(atqId: number): Observable<ApiResponse> {
    return this.apiService.delete(`article-type-quantite/${atqId}`);
  }
}
